import { ApiTags, rootApi } from "../../../../services/rootApi";
import { IShuttleBookings, IShuttleReq } from "./shuttleBooking";


const TAG = ApiTags.ShuttleBooking;
const getTags = (entities: IShuttleBookings[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]

const shuttleDetailsApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getBookings: builder.query<IShuttleBookings[], { contactId: string, bookingStatus: number, shuttleStatus: string }>({
      query: ({ contactId, bookingStatus, shuttleStatus }) => `/ShuttleDetails/contact(${contactId})/${bookingStatus}/${shuttleStatus}`,
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),
    getBookingsByContactId: builder.query<IShuttleBookings[], { contactId: string }>({
      query: ({ contactId }) => `/ShuttleDetails/(${contactId})`,
      providesTags: (result) => result ? getTags(result) : [TAG],
    }),
    createShuttleBooking: builder.mutation<IShuttleReq, Partial<IShuttleReq>>({
      query: (shuttle) => ({
        url: "/ShuttleDetails/Create",
        method: "POST",
        body: shuttle
      }),
      invalidatesTags: (result) => result ? [{ type: TAG, id: result.id }, TAG] : [TAG]
    }),
  }),
});

export const {
  useGetBookingsQuery,
  useLazyGetBookingsQuery,
  useGetBookingsByContactIdQuery,
  useLazyGetBookingsByContactIdQuery,
  useCreateShuttleBookingMutation
} = shuttleDetailsApi;